
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 13l4.48-3.53c.33-.26.86-.27 1.2-.01l1.44 1.07c.27.2.67.24.99.11l3.9-1.63-4.4 3.55c-.34.27-.89.27-1.23 0l-1.37-1.1c-.27-.21-.68-.26-1.01-.12L6 13z"}}),_c('path',{attrs:{"d":"M6 14a.99.99 0 01-.86-.49c-.25-.43-.15-.98.24-1.29l4.48-3.53c.68-.54 1.72-.55 2.41-.03l1.44 1.07 3.91-1.64a1.001 1.001 0 011.02 1.7l-4.4 3.55c-.71.57-1.77.57-2.48 0l-1.37-1.09-4 1.68c-.12.05-.26.08-.38.08L6 14zm4.97-3.66c.24.07.47.18.66.34L13 11.77l.17-.14c-.24-.06-.46-.17-.66-.31l-1.44-1.07-.1.08v.01z"}}),_c('path',{attrs:{"d":"M6 24c-.13 0-.26-.02-.38-.08C5.25 23.77 5 23.4 5 23v-4H1c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1h22c.55 0 1 .45 1 1v15c0 .55-.45 1-1 1H11.41L6.7 23.71c-.19.19-.45.29-.71.29H6zm-4-7h4c.55 0 1 .45 1 1v2.59l3.29-3.29a.99.99 0 01.71-.29h11V4H2v13z"}})])
          )
        }
      }
    